import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import TableCellStartsStyled from './styled';

class TableCellStarts extends PureComponent {
  render() {
    const { dateFrom, dateTo, dateFromTz, dateToTz } = this.props;

    const from = moment(dateFrom).tz(dateFromTz);
    const to = moment(dateTo).tz(dateToTz);

    return (
      <TableCellStartsStyled>
        <div>{from.format('ddd DD MMM')}</div>
        <div>
          {from.format('HH:mm')}-{to.format('HH:mm')}
        </div>
      </TableCellStartsStyled>
    );
  }
}

TableCellStarts.propTypes = {
  dateFrom: PropTypes.string.isRequired,
  dateTo: PropTypes.string.isRequired,
  dateFromTz: PropTypes.string.isRequired,
  dateToTz: PropTypes.string.isRequired,
};

export default TableCellStarts;
